<div *ngIf="modo==='normal'">

    <div *ngIf='usuario; else notlogin' class="usuario noselect">
        <div class="icouser pointers" (click)="closebudget()">
            <i class="mdi mdi-account-circle"
                style="font-size: 24px; color: var(--navbarColorFondo, var(--primary-color));"></i>
        </div>
        <div class="cliente pointers" (click)="closebudget()">
            <div class="clientenombre">
                {{usuario.nombre || usuario.username}}
            </div>
            <div class="puntos pointers">
                <span class="blooded">Sucursal </span>{{ nombreSucursal}}
            </div>
        </div>

        <div *ngIf='desplegado; else elseBlock' class="triangul pointers" (click)="closebudget()"></div>

        <ng-template #elseBlock>
            <div class="inversetriangule pointers" (click)="closebudget()"></div>
        </ng-template>
        <div [@openClose]="desplegado ? 'open' : 'closed'" class="extendible">
            <div class="predictions">
                <div *ngFor="let menu of menus"
                    (click)="closebudget();gotoURL(menu.url, menu.nombre);ejecutar(menu.function)"
                    (click)="indexWindow(menu.url)" class="prediccion"
                    [class.prediccion--salir]="menu.function === 'salir'"
                    [class.prediccion--separada]="menu.nombre === 'Ayuda'">
                    <div class="iconocont">
                        <i [class]="menu.icourl" class="icomobile" style="font-size: 18px;"></i>
                    </div>
                    <div class="descrip">
                        {{menu.nombre}}
                    </div>
                    <i class="mdi mdi-chevron-right flecha"></i>
                </div>
            </div>
        </div>
    </div>
    <ng-template #notlogin>
        <div (click)="loginStart()" class="iniciodes noselect" [ngStyle]="{'display': login}">
            <div class="icouser pointers">
                <i class="mdi mdi-account-circle"
                    style="font-size: 24px; color: var(--navbarColorFondo, var(--primary-color));"></i>
            </div>
            <div class="clientenombre">
                Iniciar Sesión
            </div>
        </div>

        <div class="container-carga" [ngStyle]="{'display': loader}">
            <div class="carga"></div>
        </div>
    </ng-template>
</div>